var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('node-area', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shows,
      expression: "shows"
    }],
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'node-area', {
    mode: _vm.mode,
    size: _vm.size
  }, false), [_c(`node-${_vm.value.type.toLowerCase()}`, _vm._g(_vm._b({
    tag: "component",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'component', {
    class: 'item-node__content',
    mode: _vm.mode
  }, false), {
    pull: _vm.pull,
    input: _vm.emit
  }))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }